import { createAsyncThunk } from "@reduxjs/toolkit";
import { emailCampaignService } from "../../services";

const createMessage = createAsyncThunk(
    'emailCampaign/createMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await emailCampaignService.createMessage(
                payload.companyId,
                payload.campaignId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateMessage = createAsyncThunk(
    'emailCampaign/updateMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await emailCampaignService.updateMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteMessage = createAsyncThunk(
    'emailCampaign/deleteMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await emailCampaignService.deleteMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getMessage = createAsyncThunk(
    'emailCampaign/getMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await emailCampaignService.getMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCampaignEchos = createAsyncThunk(
    'emailCampaign/getCampaignEchos',
    async (payload, ThunkAPI) => {
        try{
            const response = await emailCampaignService.getCampaignEchos(
                payload.companyId,
                payload.campaignId, 
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);


export {
    createMessage,
    updateMessage,
    deleteMessage,
    getMessage,
    getCampaignEchos,
}